module.exports = __webpack_public_path__ + "img/quiz_contest_top_brd.8b7ccca1.png";